import { create } from 'zustand';

interface StoreState {
  isDrawerShow: boolean;
  setIsDrawerShow: (isDrawerShow: boolean) => void;
}

export const useLeftPanelDrawer = create<StoreState>((set, get) => {
  return {
    isDrawerShow: false,
    setIsDrawerShow: (isDrawerShow: boolean) => {
      set({ isDrawerShow });
    },
  };
});

export const useProfileDrawer = create<StoreState>((set, get) => {
  return {
    isDrawerShow: false,
    setIsDrawerShow: (isDrawerShow: boolean) => {
      set({ isDrawerShow });
    },
  };
});

export const useSongDetailDrawer = create<StoreState>((set, get) => {
  return {
    isDrawerShow: false,
    setIsDrawerShow: (isDrawerShow: boolean) => {
      set({ isDrawerShow });
    },
  };
});
